import React from "react";

function Campaigns() {
  return <div>Campaigns</div>;
}

export default Campaigns;
